/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StationsStationsGroupsGetQueryResponse, StationsStationsGroupsGetPathParams } from "../models/StationsStationsGroupsGet";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { stationsStationsGroupsGet } from "../axios/stationsStationsGroupsGet";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const stationsStationsGroupsGetQueryKey = (stationGroupId: StationsStationsGroupsGetPathParams["stationGroupId"]) => ["api-v2", { url: '/station-groups/v1/:stationGroupId', params: {stationGroupId:stationGroupId} }] as const

export type StationsStationsGroupsGetQueryKey = ReturnType<typeof stationsStationsGroupsGetQueryKey>

export function stationsStationsGroupsGetQueryOptions(stationGroupId: StationsStationsGroupsGetPathParams["stationGroupId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = stationsStationsGroupsGetQueryKey(stationGroupId)
        return queryOptions<StationsStationsGroupsGetQueryResponse, ResponseErrorConfig<Error>, StationsStationsGroupsGetQueryResponse, typeof queryKey>({
         enabled: !!(stationGroupId),
         queryKey,
         queryFn: async ({ signal }) => {
            return stationsStationsGroupsGet(stationGroupId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns a stations group by id or slug, including its stations.
 * @summary Get stations group
 * {@link /station-groups/v1/:stationGroupId}
 */
export function useStationsStationsGroupsGet<TData = StationsStationsGroupsGetQueryResponse, TQueryData = StationsStationsGroupsGetQueryResponse, TQueryKey extends QueryKey = StationsStationsGroupsGetQueryKey>(stationGroupId: StationsStationsGroupsGetPathParams["stationGroupId"], options: 
{
  query?: Partial<QueryObserverOptions<StationsStationsGroupsGetQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? stationsStationsGroupsGetQueryKey(stationGroupId)
         

         const query = useQuery({
          ...stationsStationsGroupsGetQueryOptions(stationGroupId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}